import { createModel } from '@/store/tools';

const model = {
    namespace: 'enterprisereconciliation',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getStateList': T('getStateList'),
            'getReconciliationList': T('getReconciliationList'),
            'getReconciliationDetail': T('getReconciliationDetail'),
            'getReconciliationDetailTable': T('getReconciliationDetailTable'),

            'getReconciliationDetailList': T('getReconciliationDetailList'),
            'getTransactionNameList': T('getTransactionNameList'),
            'getIncomeDrawTypeList': T('getIncomeDrawTypeList'),

            'getEnterpriseCycleList': T('getEnterpriseCycleList'),
        },
        actions: {
            'getStateList': A('getStateList'),
            'getReconciliationList': A('getReconciliationList'),
            'getReconciliationDetail': A('getReconciliationDetail'),
            'getReconciliationDetailTable': A('getReconciliationDetailTable'),

            'getReconciliationDetailList': A('getReconciliationDetailList'),
            'getTransactionNameList': A('getTransactionNameList'),
            'getIncomeDrawTypeList': A('getIncomeDrawTypeList'),

            'getEnterpriseCycleList': A('getEnterpriseCycleList'),
        },
        sagas: {
            'getStateList': S('getStateList', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.getReconciliationStatus'),
            'getReconciliationList': S('getReconciliationList', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.queryReconciliations'),
            'getReconciliationDetail': S('getReconciliationDetail', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.getReconciliationDetail'),
            'getReconciliationDetailTable': S('getReconciliationDetailTable', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.queryReconciliationItems'),

            'getReconciliationDetailList': S('getReconciliationDetailList', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.transDetails'),
            'getTransactionNameList': S('getTransactionNameList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getIncomeDrawTypeList': S('getIncomeDrawTypeList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),

            'getEnterpriseCycleList': S('getEnterpriseCycleList', '/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.getPagerReconciliation'),
        },
        reducers: {
            'stateList': R('getStateList', []),
            'reconciliationList': R('getReconciliationList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'reconciliationDetail': R('getReconciliationDetail', {}),
            'reconciliationDetailTable': R('getReconciliationDetailTable', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),

            'transactionDetailList': R('getReconciliationDetailList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'transactionNameList': R('getTransactionNameList', []),
            'incomeDrawTypeList': R('getIncomeDrawTypeList', []),

            'enterpriseCycleList': R('getEnterpriseCycleList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
        }
    })
};
export default createModel(model);